<template>
	<div>
		<div v-if="!loading">
			<vx-card title="Voorraad pools" class="mb-5">
				<div class="w-full vx-row">
					<div class="vx-col w-full">
						<vs-alert color="danger">LET OP! Deze module is nog in Béta! Niet alles zal naar verwachting werken. Gebruik op eigen risico.</vs-alert>
						<br>
						<label>
							<b>Wat kan deze module?</b><br>
							Voorraadpools laten je meerdere EAN’s koppelen aan één centrale voorraad.
							De beschikbare voorraad wordt automatisch verdeeld over de gekoppelde EAN’s op basis van een verdeelsleutel en eventuele maximums per EAN.
							Bij verkoop of annulering wordt de centrale voorraad aangepast, worden de gekoppelde EAN-voorraden opnieuw berekend en automatisch naar bol.com bijgewerkt.
							<b>Let op!</b> Deze module werkt op dit moment enkel binnen je bol.com verkopen. Lightspeed verkopen worden niet meegenomen. Bij een annulering dien je zelf de voorraad weer aan de pool toe te voegen.
						</label>
					</div>

					<div class="vx-col w-full">
						<br>
						<label>
							<b>Kosten?</b><br>
							Deze module kost 19,95 euro per maand.
						</label>
					</div>

					<div v-if="!modulePools.active" class="vx-col w-full mt-5">
						<vs-button color="primary" type="filled" @click.native="activateModule">Activeer deze module</vs-button>
						<br>
					</div>
				</div>
			</vx-card>

			<div v-if="modulePools.active">
				<vx-card title="Module instellingen" class="mb-5">
					<div class="vx-row w-full">
						<div class="vx-col w-full">
							<p>Voorraad pools kun je beheren via menu > producten > voorraad pools</p>
						</div>
					</div>
				</vx-card>
			</div>

<!--			<div>-->
<!--				<vx-card v-if="modulePools.active" class="mb-5">-->
<!--					<div class="w-full vx-row">-->
<!--						<div class="vx-col w-full">-->
<!--							<vs-button color="primary" type="filled" style="width: 100%" @click.native="update">Opslaan</vs-button>-->
<!--						</div>-->
<!--					</div>-->
<!--				</vx-card>-->
<!--			</div>-->

			<div>
				<vx-card v-if="modulePools.active" title="Module deactiveren">
					<div class="w-full vx-row">
						<div class="vx-col w-full">
							<vs-button color="danger" type="filled" @click.native="deactivateModule">Deactiveer deze module</vs-button>
						</div>
					</div>
				</vx-card>
			</div>
		</div>
	</div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
	name: 'pools',
	data() {
		return {
			loading: true,
			modulePools: {},
		}
	},
	mounted() {
		this.$vs.loading();
		this.init();
	},
	computed: {
		...mapGetters({
			pools: 'pools/modulePools',
		})
	},
	methods: {
		init() {
			this.$store.dispatch('pools/init').then(res => {
				this.modulePools = {...this.$store.state.pools.modulePools};
				if (this.modulePools) {
					if (this.modulePools.active === null) {
						this.modulePools.active = false;
					}
				}
				this.$vs.loading.close();
				this.loading = false;
			})
		},

		update() {
			this.$vs.loading();
			const updateParams = {
				active: this.modulePools.active,
			};

			this.$store.dispatch('pools/moduleUpdate', updateParams).then(res => {
				this.$vs.notify({
					title: 'Gelukt',
					text: 'Je wijzigingen zijn opgeslagen',
					color: 'success'
				});
				this.$vs.loading.close();
			}).catch(error => {
				this.$vs.loading.close();
				this.$vs.notify({
					title: 'Oops',
					text: 'Je wijzigingen zijn niet opgeslagen, controleer je gegevens en probeer het opnieuw',
					color: 'danger'
				});
			});
		},

		activateModule() {
			this.$store.dispatch('pools/activate').then(res => {
				this.notifySuccessActivate();
				this.init();
			}).catch(err => {
				this.notifyFailed();
			});
		},

		deactivateModule() {
			this.$store.dispatch('pools/deactivate').then(res => {
				this.notifySuccessDeactivate();
				this.init();
			}).catch(err => {
				this.notifyFailed();
			});
		},

		notifySuccessActivate() {
			this.$vs.notify({
				color: 'success',
				title: 'Gelukt',
				text: 'De module is geactiveerd!',
			});
		},

		notifySuccessDeactivate() {
			this.$vs.notify({
				color: 'success',
				title: 'Gelukt',
				text: 'De module is gedeactiveerd!',
			});
		},

		notifyFailed() {
			this.$vs.notify({
				color: 'danger',
				title: 'Oops',
				text: 'Er is iets fout gegaan, probeer het later opnieuw',
			});
		},
	},
}
</script>

<style scoped>
.smallLabel {
	color: rgba(0, 0, 0, .7);
	padding-left: 5px;
	font-family: "Montserrat", Helvetica, Arial, sans-serif;
	font-weight: 400;
	font-size: .85rem;
}

ul {
	list-style-type: disc;
}
</style>
